// The public domain status, GET /provider-domain-status/:domain, answers
// { sso, passwordAllowed } about a domain, never an account (rapid-api-auth,
// organization-domain PublicStatus):
//
//   sso              'available' | 'suspended' | 'none'
//   passwordAllowed  false only when the server will refuse a password
//                    sign-in at that domain right now: the domain requires
//                    SSO, SSO works for it, and the rule is enforced.
//
// The sign-in pages use passwordAllowed to stop offering a password the
// server will refuse. Anything but an explicit false keeps the password
// path: a failed lookup, no domain, or a server from before the field. The
// pages fail open, as the server does.

export const passwordAllowedBy = status => !(status && status.passwordAllowed === false)

// The status for one domain, or null when there is no domain to ask about
// (a username) or the lookup failed (network, rate limit). Never throws.
export const fetchDomainStatus = async (api, domain) => {
  if (!domain) {
    return null
  }

  try {
    return (await api.get(domain)) || null
  } catch {
    return null
  }
}
